import { formatDurationToTime } from '../libs/helper'

export const listDeviceStatusFields = {
  computed: {
    listDeviceStatusFields() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('cdmSecurityMonitoring.field.cdmNumber'),
          tdAttr: {
            style: 'min-width:100px;',
          },
        },
        {
          key: 'lastActiveOn',
          label: this.$t('cdmSecurityMonitoring.field.lastActive'),
        },
        {
          key: 'address',
          label: this.$t('global.field.location'),
          tdAttr: {
            style: 'min-width:390px;max-width:600px;white-space:normal;',
          },
        },
        {
          key: 'isDoorOpen',
          label: this.$t('cdmSecurityMonitoring.field.doorStatus'),
        },
        {
          key: 'temperature',
          label: this.$t('cdmSecurityMonitoring.field.temperature'),
          formatter: (value) => ((value ?? '') === '' ? '-' : `${value}°C`),
        },
        {
          key: 'battery',
          label: this.$t('cdmSecurityMonitoring.field.battery'),
          formatter: (value) => ((value ?? '') === '' ? '-' : `${value}%`),
        },
        {
          key: 'powerSupply',
          label: this.$t('cdmSecurityMonitoring.field.powerSupply'),
          formatter: (value) => ((value ?? '') === '' ? 'N/A' : `${value} V`),
        },
        {
          key: 'startSchedule',
          name: 'startSchedule',
          label: this.$t('cdmSecurityMonitoring.field.startSchedule'),
          type: 'date-picker',
          format: 'HH:mm',
          clearable: false,
          valueType: 'format',
          datepickerType: 'time',
          placeholder: 'HH:mm',
          icon: 'icon-outline_clock',
          isEditable: true,
          formatter: (value) => (value ? formatDurationToTime(value) : '-'),
          customValueFn: (item) =>
            item.startSchedule ? formatDurationToTime(item.startSchedule) : null,
          validation: ['required'],
          validationBehavior: 'live',
          tdAttr: {
            style: 'min-width:130px;max-width:130px;',
          },
        },
        {
          key: 'endSchedule',
          name: 'endSchedule',
          label: this.$t('cdmSecurityMonitoring.field.endSchedule'),
          type: 'date-picker',
          format: 'HH:mm',
          clearable: false,
          valueType: 'format',
          datepickerType: 'time',
          placeholder: 'HH:mm',
          icon: 'icon-outline_clock',
          isEditable: true,
          formatter: (value) => (value ? formatDurationToTime(value) : '-'),
          customValueFn: (item) =>
            item.endSchedule ? formatDurationToTime(item.endSchedule) : null,
          validation: ['required'],
          validationBehavior: 'live',
          tdAttr: {
            style: 'min-width:130px;max-width:130px;',
          },
        },
        {
          key: 'set-buzzer-btn',
          label: this.$t('cdmSecurityMonitoring.field.buzzer'),
        },
        {
          key: 'liveStreamBtn',
          label: this.$t('cdmSecurityMonitoring.field.liveStreaming'),
        },
      ]
    },
  },
}
